import React from 'react'

const Leader = (props) => {
  return (
    <div className='section-nav Leadership-single'>
      <div className='heading'>{props.data.name}</div>
      <div className='container'>
        <div className='row'>
          <div className='col-md-4'>
            <img src={props.data.image} />
          </div>
          <div className='col-md-8'>
            <p>{props.data.about}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Leader
